import { useState } from 'react';
import { DisaggregatedMetric, GeoTag } from '../services/types';
import useDeepCompareEffect from './useDeepCompareEffect';
import { orgId } from '../utils/dashboardUtils';
import { indicatorsEnv } from '../utils/environment';

interface GeoDetails {
    lod: string;
    ids: string[]
};

const useFetchMetric = (geoDetails: GeoDetails[], metricId: number, geoTag: GeoTag | null) => {
    const [metricData, setMetricData] = useState<DisaggregatedMetric[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);
    
    const geoEncoding = 'delta';

    const url = `${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getindicatorbyid`;

    useDeepCompareEffect(() => {
        if (!metricId) return;

        const fetchData = async () => {
            try {
                if (orgId !== null) {

                    console.log(`Fetching metric data for ${metricId}...`)
                    // Fetch metric data
                    const metricResponse = await fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ geoDetails, orgId, metricId, geoEncoding, geoTag, environment: indicatorsEnv }),
                    });

                    if (!metricResponse.ok) {
                        throw new Error('Network response was not ok');
                    }

                    const metricResult = await metricResponse.json();
                    setMetricData(metricResult.data);
                }
            } catch (error: any) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [geoDetails, orgId, metricId]);

    return { metricData, loading, error };
};

export default useFetchMetric;